var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "px-3 m-4 mr-0 sm:px-4 py-3 flex items-center justify-between",
      class: _vm.containerClass,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex-1 flex items-center justify-end sm:justify-between",
        },
        [
          _c("div", { staticClass: "ml-auto mr-3 customWidthPage bg-white" }, [
            _c(
              "select",
              {
                staticClass:
                  "block form-select w-full transition duration-150 ease-in-out px-3 py-2 text-priamry-black sm:text-sm sm:leading-5",
                attrs: { id: "invitation-limit" },
                domProps: { value: _vm.config.limit },
                on: { input: (e) => _vm.updatedLimit(e.target.value) },
              },
              [
                _c("option", { domProps: { value: 5 } }, [_vm._v("5 / page")]),
                _c("option", { domProps: { value: 8 } }, [_vm._v("8 / page")]),
                _c("option", { domProps: { value: 15 } }, [
                  _vm._v("15 / page"),
                ]),
                _c("option", { domProps: { value: 25 } }, [
                  _vm._v("25 / page"),
                ]),
                _c("option", { domProps: { value: 50 } }, [
                  _vm._v("50 / page"),
                ]),
              ]
            ),
          ]),
          _c("div", [
            _c(
              "nav",
              {
                staticClass:
                  "relative z-0 inline-flex shadow-sm customArrowHeight bg-white",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "cursor-pointer relative inline-flex items-center px-2 py-2 rounded-l-sm border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150 disabled:bg-cool-gray-100 disabled:text-gray-300",
                    attrs: {
                      disabled: _vm.config.page === 1,
                      "aria-label": "Previous",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.prev.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9.89846 2.98381V1.92698C9.89846 1.83538 9.79318 1.78479 9.72209 1.84085L3.55881 6.65471C3.50644 6.69544 3.46407 6.74758 3.43492 6.80717C3.40578 6.86676 3.39062 6.93222 3.39062 6.99856C3.39062 7.0649 3.40578 7.13036 3.43492 7.18995C3.46407 7.24954 3.50644 7.30168 3.55881 7.34241L9.72209 12.1563C9.79455 12.2123 9.89846 12.1617 9.89846 12.0701V11.0133C9.89846 10.9463 9.86701 10.8821 9.81506 10.841L4.89318 6.99924L9.81506 3.15608C9.86701 3.11506 9.89846 3.05081 9.89846 2.98381Z",
                            fill: "#717986",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass:
                      "cursor-pointer -ml-px relative inline-flex items-center px-2 py-2 rounded-r-sm border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150 disabled:bg-cool-gray-100 disabled:text-gray-300",
                    attrs: {
                      disabled: _vm.resultToValue >= _vm.config.total,
                      "aria-label": "Next",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.next.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M10.4685 6.65558L4.30527 1.84171C4.28917 1.82903 4.26981 1.82115 4.24943 1.81897C4.22905 1.8168 4.20847 1.82042 4.19005 1.82941C4.17164 1.83841 4.15613 1.85241 4.14531 1.86982C4.1345 1.88724 4.12881 1.90734 4.12891 1.92784V2.98468C4.12891 3.05167 4.16035 3.11593 4.21231 3.15694L9.13417 7.00011L4.21231 10.8433C4.15899 10.8843 4.12891 10.9485 4.12891 11.0155V12.0724C4.12891 12.164 4.23418 12.2146 4.30527 12.1585L10.4685 7.34464C10.5209 7.30378 10.5633 7.25151 10.5924 7.19181C10.6216 7.13211 10.6367 7.06654 10.6367 7.00011C10.6367 6.93367 10.6216 6.86811 10.5924 6.80841C10.5633 6.74871 10.5209 6.69644 10.4685 6.65558Z",
                            fill: "#717986",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }